/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneVideoReels from 'base/components/standalone/VideoReels';

export const DynamicStandaloneVideoReels = StandaloneVideoReels;
export type DynamicStandaloneVideoReelsProps = PropsFromComponent<typeof StandaloneVideoReels>;

export const DynamicStandaloneVideoReelsWith = (extras: DynamicStandaloneExtras): typeof StandaloneVideoReels => {
    return function DynamicStandaloneVideoReels(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'VideoReels');
        return <StandaloneVideoReels {...mergeProps({ options: { theme } }, props)} />;
    }
}